// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Cx2Z","inner":"Footer_inner__2GnDr","nextIcon":"Footer_nextIcon__1i1nb","innerLeft":"Footer_innerLeft__2ocum"};